import { openBlock as c, createElementBlock as t, createStaticVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}, o = /* @__PURE__ */ e('<g fill="currentColor" clip-path="url(#filled-document_svg__a)"><path d="M10.622.5v2.75c0 .275-.225.5-.5.5h-4.95a.5.5 0 0 1-.5-.5V.5c0-.275.225-.5.5-.5h4.925c.3 0 .525.225.525.5"></path><path d="M12.722 1.475h-1.125v1.75c0 .825-.675 1.5-1.5 1.5H5.172c-.825 0-1.5-.675-1.5-1.5v-1.75H2.547c-.825 0-1.5.675-1.5 1.5V14.5c0 .825.675 1.5 1.5 1.5h10.175c.825 0 1.5-.675 1.5-1.5V2.975c0-.825-.675-1.5-1.5-1.5m-1.375 12.2h-7.4a.5.5 0 0 1-.5-.5c0-.275.225-.5.5-.5h7.425c.275 0 .5.225.5.5s-.25.5-.525.5m0-3h-7.4a.5.5 0 0 1-.5-.5c0-.275.225-.5.5-.5h7.425c.275 0 .5.225.5.5s-.25.5-.525.5m0-3h-7.4a.5.5 0 0 1-.5-.5c0-.275.225-.5.5-.5h7.425c.275 0 .5.225.5.5s-.25.5-.525.5"></path></g><defs><clipPath id="filled-document_svg__a"><path fill="currentColor" d="M.75 0h13.793v16H.75z"></path></clipPath></defs>', 2), l = [
  o
];
function a(n, r) {
  return c(), t("svg", h, [...l]);
}
const s = { render: a };
export {
  s as default,
  a as render
};
